const getBaseUrl = lang => `${lang ? `/${lang}` : ''}/webmaster`;

export const getIndexUrl = lang => `${getBaseUrl(lang)}/index.php`;

const urlsMap = window.LANDING_APP.pageToRelUrlMap;

export const getTermsUrl = () => urlsMap.terms;

export const getWebmasterAgreementUrl = () => urlsMap.affagreement;
